import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '@sm/intl';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import PromptInput from '@mntv-ml-platform/prompt-input';
const COPY = {
  PromptInputPlaceholder: {
    id: 'buildWithAI.PromptInputAvailable.PromptInputPlaceholder',
    defaultMessage: 'Type your prompt here.',
    description: '[Type: label][Vis: med] - Placeholder for prompt input textbox'
  },
  PromptsRemaining: {
    id: 'buildWithAI.PromptInputAvailable.PromptsRemaining',
    defaultMessage: 'Prompts remaining: {promptsRemaining}',
    description: '[Type: label][Vis: med] - Indicated how many more times the user can submit a prompt'
  }
};
const MinPromptRemainingWarningLevel = 2;
/**
 * The prompt input, with remaining prompt count.
 */
const PromptInputAvailable = ({
  disabled,
  loading,
  onPrompt,
  promptsRemaining
}) => {
  const promptsLow = promptsRemaining <= MinPromptRemainingWarningLevel;
  const promptsRemainingText = t(COPY.PromptsRemaining, {
    promptsRemaining
  });
  return _jsxs(_Fragment, {
    children: [_jsx(PromptInput, {
      disabled: disabled,
      id: "ask-ai-prompt-input",
      loading: loading,
      onPrompt: onPrompt,
      placeholder: t(COPY.PromptInputPlaceholder)
    }), _jsx(Box, {
      mt: 1,
      children: _jsx(Typography, {
        component: "p",
        variant: "bodySm",
        color: promptsLow ? 'error' : 'dark',
        role: promptsLow ? 'alert' : undefined,
        "aria-label": promptsRemainingText,
        children: promptsRemainingText
      })
    })]
  });
};
export default PromptInputAvailable;